module.exports = __webpack_public_path__ + "images/category_lp/game_console/assessment_achievements/1@2x_a0a5035ffafd4062555c8ab7fbc979fa.png";